import { isCountertopProduct } from '~/core/helpers';
import { ColorModel, PricedProduct } from '~/core/models';

export interface PriceTotalsReturn {
  priceWithoutDiscount: number;
  priceWithDiscount: number;
}

/**
 * calculates the total price for all products applying the small job logic
 * @param pricedProducts
 * @param selectedColor
 * @param isSmallJob
 * @param useMinQtyAreaForPricing
 * @param smallJobMinimumArea
 */
export const calculateTotalPrice = (args: {
  pricedProducts: PricedProduct[];
  selectedColor: ColorModel | undefined;
  isSmallJob: boolean;
  useMinQtyAreaForPricing: boolean;
  smallJobMinimumArea: number;
}): PriceTotalsReturn => {
  const {
    pricedProducts,
    selectedColor,
    isSmallJob,
    useMinQtyAreaForPricing,
    smallJobMinimumArea,
  } = args;
  const unitPrice = selectedColor ? selectedColor.price : 0;
  const unitPriceWithoutDiscount = selectedColor
    ? selectedColor.priceWithoutDiscount
    : 0;
  // the minimum sq ft allowed is per-material, butcher block is 20 for example

  const totals = pricedProducts.reduce(
    (acc, currentProduct) => ({
      countertopQty: (acc.countertopQty += isCountertopProduct(currentProduct)
        ? currentProduct.quantity
        : 0),
      priceWithDiscount: acc.priceWithDiscount + currentProduct.price,
      priceWithoutDiscount:
        acc.priceWithoutDiscount + currentProduct.priceWithoutDiscount,
    }),
    { priceWithoutDiscount: 0, priceWithDiscount: 0, countertopQty: 0 }
  );
  const minQtyDelta = isSmallJob
    ? smallJobMinimumArea - totals.countertopQty
    : 0;

  const actualPriceWithoutDiscount = totals.priceWithoutDiscount;
  const actualPriceWithDiscount = totals.priceWithDiscount;
  const adjustedForMinPriceWithoutDiscount =
    totals.priceWithoutDiscount + minQtyDelta * unitPriceWithoutDiscount;
  const adjustedForMinPriceWithDiscount =
    totals.priceWithDiscount + minQtyDelta * unitPrice;

  return totals.countertopQty > 0
    ? {
        priceWithoutDiscount: useMinQtyAreaForPricing
          ? adjustedForMinPriceWithoutDiscount
          : actualPriceWithoutDiscount,
        priceWithDiscount: useMinQtyAreaForPricing
          ? adjustedForMinPriceWithDiscount
          : actualPriceWithDiscount,
      }
    : {
        priceWithoutDiscount: 0,
        priceWithDiscount: 0,
      };
};
